import React, { CSSProperties, Suspense } from 'react';
import { DangerousHTML } from './components/DangerousHTML';
import { HomePageHero } from './components/HomePageHero';
import { Container } from './components/Container';
import RoundedButtonWithTextAround from './components/RoundedButtonWithTextAround';
import Claim from './components/Claim';
import { DonateCTA } from './components/DonateCTA';
import { JoinCTA } from './components/JoinCTA';

const EmptySuspense: React.FC<any> = ({ children }) => (
  <Suspense fallback={null}>
    {children}
  </Suspense>
);

export const HomeContent: React.FC<any> = (props) => (
  <main>
    <EmptySuspense>
      <HomePageHero {...props} />
    </EmptySuspense>
    <EmptySuspense>
      <Claim text={props.claim} />
    </EmptySuspense>
    <div className="pillars" id="#filary">
      {props.pillars?.map((p: Record<string, any>) => {
        const style = {
          '--color-bg': p.colorbg,
          '--color-txt': p.colortxt,
        } as CSSProperties;
        return (
          <EmptySuspense key={p.headline}>
            <div
              key={p.headline}
              className="pillars__item pillars__item--animate"
              style={style}
            >
              <Container>
                <div className="pillars__item__body">
                  <DangerousHTML element="h2" html={p.headline} />
                  <DangerousHTML element="div" html={p.description} />
                </div>
                <div className="pillars__item__actions">
                  <RoundedButtonWithTextAround text={p.headline} url={p.link} color={p.colortxt} />
                </div>
              </Container>
            </div>
          </EmptySuspense>
        );
      })}
    </div>
    {props.language === 'pl' && (
      <EmptySuspense>
        <DonateCTA donateCTA={props.donateCTA} />
      </EmptySuspense>
    )}
    <EmptySuspense>
      <JoinCTA joinCTA={props.joinCTA} />
    </EmptySuspense>
  </main>
);
